import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Controller, useFormContext } from 'react-hook-form';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Checkbox from '@material-ui/core/Checkbox';
import Paper from '@material-ui/core/Paper';
import HelpOutlineOutlined from '@material-ui/icons/HelpOutlineOutlined';
import Tooltip from '@material-ui/core/Tooltip';
import { axiosInstance } from '../../axiosInstance';

const Actions = () => {
  const { t } = useTranslation();
  const { control, watch, setValue } = useFormContext();
  const watchActions = watch('actions');
  const [checkedValues, setCheckedValues] = useState<string[]>([]);
  const [supportedActions, setSupportedActions] = useState([]);

  useEffect(() => {
    setCheckedValues(watchActions || []);
  }, []);

  const handleSelect = (checkedName: string) => {
    const newNames = checkedValues?.includes(checkedName)
      ? checkedValues?.filter((name: string) => name !== checkedName)
      : [...(checkedValues ?? []), checkedName];
    setCheckedValues(newNames);

    return newNames;
  };

  useEffect(() => {
    const onLoad = async () => {
      const {
        data: { actions }
      } = await axiosInstance.get('/acls/policies/supported-actions');
      setSupportedActions(actions);
    };
    onLoad();
  }, []);

  return (
    <>
      <div style={{ margin: '25px 0 15px' }}>
        <h5>{t('acl.actions')}</h5>
      </div>
      <TableContainer component={Paper} elevation={3}>
        <Table stickyHeader aria-label="order list">
          <TableHead>
            <TableRow>
              <TableCell>{t('acl.actions')}</TableCell>
              <TableCell style={{ width: '5%' }} />
            </TableRow>
          </TableHead>
          <TableBody>
            {supportedActions.map(name => (
              <TableRow
                key={name}
                hover
                onClick={() => {
                  setValue('actions', handleSelect(name));
                }}
                style={{ cursor: 'pointer' }}
              >
                <TableCell>
                  <Controller
                    name="actions"
                    control={control}
                    render={({ onChange: onCheckChange }) => (
                      <Checkbox
                        checked={checkedValues.includes(name)}
                        onClick={e => e.stopPropagation()}
                        onChange={e => {
                          e.stopPropagation();
                          onCheckChange(handleSelect(name));
                        }}
                      />
                    )}
                  />
                  {t(`acl.policy.actions.${name}.name`)}
                </TableCell>
                <TableCell style={{ width: '5%' }}>
                  <Tooltip title={t(`acl.policy.actions.${name}.hint`) || ''} arrow>
                    <HelpOutlineOutlined />
                  </Tooltip>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export { Actions };
